export default __webpack_public_path__ + "static/media/mitsubishi.4a16c0a4.png";